export function useHaptics() {
  const tap = () => {
    if (typeof navigator === 'undefined') return;
    if ('vibrate' in navigator) {
      try {
        navigator.vibrate(12);
      } catch {
        // best effort
      }
    }
  };

  const toggle = () => {
    if (typeof navigator === 'undefined') return;
    if ('vibrate' in navigator) {
      try {
        navigator.vibrate([16, 40, 16]);
      } catch {
        // best effort
      }
    }
  };

  return { tap, toggle };
}
